import React, { useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import dayjs from "dayjs";
import { Action } from "../../../constants/Common";
import { ChangeRequestModule } from "../../../constants/Module";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";
import { Input } from "reactstrap";


const IndividualDeliverable = (props) => {
  const [openAlert, setOpenAlert] = useState(false);

  const handleKeyDownCost = (event) => {
    if (event.keyCode === 8 || event.keyCode === 13) {
      return;
    }
    const value = event.target.value;
    const regex = /^\d*\.?\d{0,2}$/;

    if (!regex.test(value + event.key)) {
      event.preventDefault();
    }
  };

  const handleKeyDownWeight = (event) => {
    if (event.keyCode === 8 || event.keyCode === 13) {
      return;
    }

    const regex = /^[0-9]+$/;

    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  };

  const dateValidation = () => {
    if (
      typeof props?.eachDeliverable?.startDate === "object" &&
      typeof props?.eachDeliverable?.endDate === "object"
    ) {
      if (props.updatedProject) {
        if (
          props?.eachDeliverable?.startDate?.old <
          props.updatedProject?.startDate?.new
        ) {
          return toast.error(
            `Deliverable ${props?.eachDeliverable.name} start date ${dayjs(
              props?.eachDeliverable?.startDate.old
            ).format(
              "MM/DD/YYYY"
            )} cannot be greater than project requested start date ${dayjs(
              props.updatedProject?.startDate?.new
            ).format("MM/DD/YYYY")}`
          );
        }
        if (
          props?.eachDeliverable?.endDate?.old >
          props.updatedProject?.endDate?.new
        ) {
          return toast.error(
            `Deliverable ${props?.eachDeliverable.name} end date ${dayjs(
              props?.eachDeliverable?.endDate.old
            ).format(
              "MM/DD/YYYY"
            )} cannot be less than project requested end date ${dayjs(
              props.updatedProject?.endDate?.new
            ).format("MM/DD/YYYY")}`
          );
        }
      }

      for (const item of props.createdMilestones) {
        if (props?.eachDeliverable?.startDate?.old > item?.estimatedStartDate) {
          return toast.error(
            `Milestone ${item.name} start date ${dayjs(
              item.estimatedStartDate
            ).format(
              "MM/DD/YYYY"
            )} cannot be greater than deliverable start date ${dayjs(
              props?.eachDeliverable?.startDate?.old
            ).format("MM/DD/YYYY")}`
          );
        }

        if (props?.eachDeliverable?.endDate?.old < item?.estimatedEndDate) {
          return toast.error(
            `Milestone ${item.name} end date ${dayjs(
              item?.estimatedEndDate
            ).format(
              "MM/DD/YYYY"
            )} cannot be less than deliverable end date ${dayjs(
              props?.eachDeliverable?.endDate?.old
            ).format("MM/DD/YYYY")}`
          );
        }
      }

      for (const item of props.updatedMilestones) {
        if (
          props?.eachDeliverable?.startDate?.old > item?.estimatedStartDate?.new
        ) {
          return toast.error(
            `Milestone ${item.name} start date ${dayjs(
              item.estimatedStartDate?.new
            ).format(
              "MM/DD/YYYY"
            )} cannot be greater than deliverable start date ${dayjs(
              props?.eachDeliverable?.startDate?.old
            ).format("MM/DD/YYYY")}`
          );
        }

        if (
          props?.eachDeliverable?.endDate?.old < item?.estimatedEndDate?.new
        ) {
          return toast.error(
            `Milestone ${item.name} end date ${dayjs(
              item?.estimatedEndDate?.new
            ).format(
              "MM/DD/YYYY"
            )} cannot be less than deliverable end date ${dayjs(
              props?.eachDeliverable?.endDate?.old
            ).format("MM/DD/YYYY")}`
          );
        }
      }
    }
    if (typeof props?.eachDeliverable?.startDate === "object") {
      if (props.updatedProject) {
        if (
          props?.eachDeliverable?.startDate?.old <
          props.updatedProject?.startDate?.new
        ) {
          return toast.error(
            `Deliverable ${props?.eachDeliverable.name} start date ${dayjs(
              props?.eachDeliverable?.startDate.new
            ).format(
              "MM/DD/YYYY"
            )} cannot be greater than project start date ${dayjs(
              props?.eachDeliverable?.startDate?.old
            ).format("MM/DD/YYYY")}`
          );
        }
      }

      for (const item of props.createdMilestones) {
        if (props?.eachDeliverable?.startDate?.old > item?.estimatedStartDate) {
          return toast.error(
            `Milestone ${item.name} start date ${dayjs(
              item.estimatedStartDate
            ).format(
              "MM/DD/YYYY"
            )} cannot be greater than deliverable start date ${dayjs(
              props?.eachDeliverable?.startDate?.old
            ).format("MM/DD/YYYY")}`
          );
        }
      }

      for (const item of props.updatedMilestones) {
        if (
          props?.eachDeliverable?.startDate?.old > item?.estimatedStartDate?.new
        ) {
          return toast.error(
            `Milestone ${item.name} start date ${dayjs(
              item.estimatedStartDate?.new
            ).format(
              "MM/DD/YYYY"
            )} cannot be greater than deliverable start date ${dayjs(
              props?.eachDeliverable?.startDate?.old
            ).format("MM/DD/YYYY")}`
          );
        }
      }
    }

    if (typeof props?.eachDeliverable?.endDate === "object") {
      if (props.updatedProject) {
        if (
          props?.eachDeliverable?.endDate?.old >
          props.updatedProject?.endDate?.new
        ) {
          return toast.error(
            `Deliverable ${props?.eachDeliverable.name} end date ${dayjs(
              props?.eachDeliverable?.endDate.new
            ).format(
              "MM/DD/YYYY"
            )} cannot be greater than project end date ${dayjs(
              props?.eachDeliverable?.endDate?.old
            ).format("MM/DD/YYYY")}`
          );
        }
      }

      for (const item of props.createdMilestones) {
        if (props?.eachDeliverable?.endDate?.old < item?.estimatedEndDate) {
          return toast.error(
            `Milestone ${item.name} end date ${dayjs(
              item?.estimatedEndDate
            ).format(
              "MM/DD/YYYY"
            )} cannot be greater than deliverable end date ${dayjs(
              props?.eachDeliverable?.endDate?.old
            ).format("MM/DD/YYYY")}`
          );
        }
      }

      for (const item of props.updatedMilestones) {
        if (
          props?.eachDeliverable?.endDate?.old < item?.estimatedEndDate?.new
        ) {
          return toast.error(
            `Milestone ${item.name} end date ${dayjs(
              item?.estimatedEndDate?.new
            ).format(
              "MM/DD/YYYY"
            )} cannot be greater than deliverable end date ${dayjs(
              props?.eachDeliverable?.endDate?.old
            ).format("MM/DD/YYYY")}`
          );
        }
      }
    }
    setOpenAlert(true);
  };

  return (
    <div className="editDeliverable_height h-auto my-4">
      <div className="dashed_border position-relative p-2">
        <div className="row">
          <div className="col-md-12 mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Name")}
              name="name"
              inputProps={{
                readOnly: true,
              }}
              required
              variant={`${
                typeof props?.eachDeliverable?.name === "object"
                  ? "filled"
                  : "outlined"
              }`}
              value={
                props?.action === Action.CREATE
                  ? props?.eachDeliverable?.name ?? ""
                  : typeof props?.eachDeliverable?.name === "object"
                  ? props?.eachDeliverable?.name?.new
                  : props?.eachDeliverable?.name
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 mt-2">
            <TextField
              fullWidth
              className="form-control"
              id="deliverable-title-input"
              label={props.t("Description")}
              name="description"
              inputProps={{
                readOnly: true,
              }}
              variant={`${
                typeof props?.eachDeliverable?.description === "object"
                  ? "filled"
                  : "outlined"
              }`}
              value={
                props?.action === Action.CREATE
                  ? props?.eachDeliverable?.description ?? ""
                  : typeof props?.eachDeliverable?.description === "object"
                  ? props?.eachDeliverable?.description?.new
                  : props?.eachDeliverable?.description
              }
              multiline
              required
              rows={2}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 mt-2">
            <TextField
              fullWidth
              className="form-control"
              id="deliverable-title-input"
              label={props.t("Expected Output")}
              name="expectedOutput"
              inputProps={{
                readOnly: true,
              }}
              variant={`${
                typeof props?.eachDeliverable?.expectedOutput === "object"
                  ? "filled"
                  : "outlined"
              }`}
              value={
                props?.action === Action.CREATE
                  ? props?.eachDeliverable?.expectedOutput ?? ""
                  : typeof props?.eachDeliverable?.expectedOutput === "object"
                  ? props?.eachDeliverable?.expectedOutput?.new
                  : props?.eachDeliverable?.expectedOutput
              }
              multiline
              required
              rows={3}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 mt-2 pe-0">
            {/* <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Cost")}
              name="cost"
              onKeyDown={handleKeyDownCost}
              required
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">SAR</InputAdornment>
                ),
              }}
              inputProps={{
                readOnly: true,
              }}
              variant={`${
                typeof props?.eachDeliverable?.cost === "object"
                  ? "filled"
                  : "outlined"
              }`}
              value={
                props?.action === Action.CREATE
                  ? props?.eachDeliverable?.cost ?? ""
                  : typeof props?.eachDeliverable?.cost === "object"
                  ? props?.eachDeliverable?.cost?.new
                  : props?.eachDeliverable?.cost
              }
            /> */}
            <TextField
              sx={{ marginLeft: 3 }}
              minimumValue="0"
              id="milestone-cost"
              // label='Deliverable Cost'
              decimalPlaces={2}
              inputProps={{
                readOnly: true,
              }}
              className="m-0"
              // size="small"
              currencySymbol={props.t("SAR")}
              fullWidth
              placeholder={props.t("Deliverable Cost")}
              variant={`${
                typeof props?.eachDeliverable?.cost === "object"
                  ? "filled"
                  : "outlined"
              }`}
              value={
                props?.action === Action.CREATE
                  ? props?.eachDeliverable?.cost ?? ""
                  : typeof props?.eachDeliverable?.cost === "object"
                  ? props?.eachDeliverable?.cost?.new
                  : props?.eachDeliverable?.cost
              }
            />
          </div>
          <div className="col-md-6 mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Weight")}
              name="weight"
              onKeyDown={handleKeyDownWeight}
              required
              inputProps={{
                readOnly: true,
              }}
              variant={`${
                typeof props?.eachDeliverable?.weight === "object"
                  ? "filled"
                  : "outlined"
              }`}
              value={
                props?.action === Action.CREATE
                  ? props?.eachDeliverable?.weight >= 0
                    ? props?.eachDeliverable?.weight
                    : ""
                  : typeof props?.eachDeliverable?.weight === "object"
                  ? props?.eachDeliverable?.weight?.new
                  : props?.eachDeliverable?.weight
              }
            />
          </div>
        </div>
        <div className="row">
          <div className=" col-md-6 changeRequest_datePicker mt-2 pe-0">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Start Date")}
              ScheduleModule
              name="startDate"
              required
              inputProps={{
                readOnly: true,
              }}
              variant={`${
                typeof props?.eachDeliverable?.startDate === "object"
                  ? "filled"
                  : "outlined"
              }`}
              value={
                props?.action === Action.CREATE
                  ? (props?.eachDeliverable?.startDate
                      ? dayjs(props?.eachDeliverable?.startDate)
                      : ""
                    ).format("DD-MM-YYYY")
                  : typeof props?.eachDeliverable?.startDate === "object" &&
                    props?.eachDeliverable?.startDate?.new
                  ? dayjs(props?.eachDeliverable?.startDate?.new).format(
                      "DD-MM-YYYY"
                    )
                  : props?.eachDeliverable?.startDate
                  ? dayjs(props?.eachDeliverable?.startDate).format(
                      "DD-MM-YYYY"
                    )
                  : ""
              }
            />
          </div>
          <div className="col-md-6 changeRequest_datePicker mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("End Date")}
              name="endDate"
              required
              readOnly={true}
              variant={`${
                typeof props?.eachDeliverable?.endDate === "object"
                  ? "filled"
                  : "outlined"
              }`}
              value={
                props?.action === Action.CREATE
                  ? props?.eachDeliverable?.endDate
                    ? dayjs(props?.eachDeliverable?.endDate).format(
                        "DD-MM-YYYY"
                      )
                    : ""
                  : typeof props?.eachDeliverable?.endDate === "object" &&
                    props?.eachDeliverable?.endDate?.new
                  ? dayjs(props?.eachDeliverable?.endDate?.new).format(
                      "DD-MM-YYYY"
                    )
                  : props?.eachDeliverable?.endDate
                  ? dayjs(props?.eachDeliverable?.endDate).format("DD-MM-YYYY")
                  : ""
              }
            />
          </div>
        </div>
        <div className="d-flex justify-content-end align-items-center mt-2 mx-2">
          <button
            className="edit_button"
            onClick={() => {
              if (
                props.action === Action.UPDATE &&
                (typeof props?.eachDeliverable?.startDate === "object" ||
                  typeof props?.eachDeliverable?.endDate === "object")
              ) {
                dateValidation();
              } else {
                setOpenAlert(true);
              }
            }}
          >
            {props.t("Delete")}
          </button>
        </div>
      </div>
      {openAlert && (
        <SweetAlert
          title={props.t("Are you sure want to delete this deliverable") + "?"}
          warning
          showCancel
          confirmBtnText={props.t("OK")}
          cancelBtnText={props.t("Cancel")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            setOpenAlert(false);
            props?.removeItemFromPayload(
              {
                ...props?.eachDeliverable,
                event: props?.action,
                module: ChangeRequestModule.DELIVERABLE,
              },
              props?.eachDeliverableIndex
            );
          }}
          onCancel={() => {
            setOpenAlert(false);
          }}
        ></SweetAlert>
      )}
    </div>
  );
};

export default withTranslation()(IndividualDeliverable);
